/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ACSBaseService } from '../acs-base-service';
import { ACSApiConfiguration } from '../acs-api-configuration';
import { ACSStrictHttpResponse } from '../acs-strict-http-response';

import { lobbyDeleteIdDelete } from '../fn/lobby/lobby-delete-id-delete';
import { LobbyDeleteIdDelete$Params } from '../fn/lobby/lobby-delete-id-delete';
import { lobbyIdGet } from '../fn/lobby/lobby-id-get';
import { LobbyIdGet$Params } from '../fn/lobby/lobby-id-get';
import { lobbyIdImagesPost } from '../fn/lobby/lobby-id-images-post';
import { LobbyIdImagesPost$Params } from '../fn/lobby/lobby-id-images-post';
import { lobbyImageContentIdGet } from '../fn/lobby/lobby-image-content-id-get';
import { LobbyImageContentIdGet$Params } from '../fn/lobby/lobby-image-content-id-get';
import { lobbyImageIdGet } from '../fn/lobby/lobby-image-id-get';
import { LobbyImageIdGet$Params } from '../fn/lobby/lobby-image-id-get';
import { LobbyImageModel } from '../models/lobby-image-model';
import { LobbyImageModelSearchResultModel } from '../models/lobby-image-model-search-result-model';
import { lobbyImagePost } from '../fn/lobby/lobby-image-post';
import { LobbyImagePost$Params } from '../fn/lobby/lobby-image-post';
import { lobbyLobbyImageContentLobbyIdGet } from '../fn/lobby/lobby-lobby-image-content-lobby-id-get';
import { LobbyLobbyImageContentLobbyIdGet$Params } from '../fn/lobby/lobby-lobby-image-content-lobby-id-get';
import { LobbyModel } from '../models/lobby-model';
import { LobbyModelSearchResultModel } from '../models/lobby-model-search-result-model';
import { lobbySavePost } from '../fn/lobby/lobby-save-post';
import { LobbySavePost$Params } from '../fn/lobby/lobby-save-post';
import { lobbySearchPost } from '../fn/lobby/lobby-search-post';
import { LobbySearchPost$Params } from '../fn/lobby/lobby-search-post';

@Injectable({ providedIn: 'root' })
export class ACSLobbyService extends ACSBaseService {
  constructor(config: ACSApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `lobbySearchPost()` */
  static readonly LobbySearchPostPath = '/Lobby/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbySearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbySearchPost$Response(params?: LobbySearchPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyModelSearchResultModel>> {
    return lobbySearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbySearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbySearchPost(params?: LobbySearchPost$Params, context?: HttpContext): Observable<LobbyModelSearchResultModel> {
    return this.lobbySearchPost$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<LobbyModelSearchResultModel>): LobbyModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `lobbyIdGet()` */
  static readonly LobbyIdGetPath = '/Lobby/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyIdGet$Response(params: LobbyIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyModel>> {
    return lobbyIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyIdGet(params: LobbyIdGet$Params, context?: HttpContext): Observable<LobbyModel> {
    return this.lobbyIdGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<LobbyModel>): LobbyModel => r.body)
    );
  }

  /** Path part for operation `lobbySavePost()` */
  static readonly LobbySavePostPath = '/Lobby/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbySavePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbySavePost$Response(params?: LobbySavePost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<string>> {
    return lobbySavePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbySavePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbySavePost(params?: LobbySavePost$Params, context?: HttpContext): Observable<string> {
    return this.lobbySavePost$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `lobbyDeleteIdDelete()` */
  static readonly LobbyDeleteIdDeletePath = '/Lobby/Delete/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyDeleteIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyDeleteIdDelete$Response(params: LobbyDeleteIdDelete$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
    return lobbyDeleteIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyDeleteIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyDeleteIdDelete(params: LobbyDeleteIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.lobbyDeleteIdDelete$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lobbyIdImagesPost()` */
  static readonly LobbyIdImagesPostPath = '/Lobby/{id}/Images';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyIdImagesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbyIdImagesPost$Response(params: LobbyIdImagesPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyImageModelSearchResultModel>> {
    return lobbyIdImagesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyIdImagesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbyIdImagesPost(params: LobbyIdImagesPost$Params, context?: HttpContext): Observable<LobbyImageModelSearchResultModel> {
    return this.lobbyIdImagesPost$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<LobbyImageModelSearchResultModel>): LobbyImageModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `lobbyImageIdGet()` */
  static readonly LobbyImageIdGetPath = '/Lobby/Image/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyImageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyImageIdGet$Response(params: LobbyImageIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyImageModel>> {
    return lobbyImageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyImageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyImageIdGet(params: LobbyImageIdGet$Params, context?: HttpContext): Observable<LobbyImageModel> {
    return this.lobbyImageIdGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<LobbyImageModel>): LobbyImageModel => r.body)
    );
  }

  /** Path part for operation `lobbyImagePost()` */
  static readonly LobbyImagePostPath = '/Lobby/Image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyImagePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbyImagePost$Response(params?: LobbyImagePost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<string>> {
    return lobbyImagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyImagePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  lobbyImagePost(params?: LobbyImagePost$Params, context?: HttpContext): Observable<string> {
    return this.lobbyImagePost$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `lobbyImageContentIdGet()` */
  static readonly LobbyImageContentIdGetPath = '/Lobby/ImageContent/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyImageContentIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyImageContentIdGet$Response(params: LobbyImageContentIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
    return lobbyImageContentIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyImageContentIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyImageContentIdGet(params: LobbyImageContentIdGet$Params, context?: HttpContext): Observable<void> {
    return this.lobbyImageContentIdGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lobbyLobbyImageContentLobbyIdGet()` */
  static readonly LobbyLobbyImageContentLobbyIdGetPath = '/Lobby/LobbyImageContent/{lobbyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lobbyLobbyImageContentLobbyIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyLobbyImageContentLobbyIdGet$Response(params: LobbyLobbyImageContentLobbyIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<Array<LobbyImageModel>>> {
    return lobbyLobbyImageContentLobbyIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lobbyLobbyImageContentLobbyIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lobbyLobbyImageContentLobbyIdGet(params: LobbyLobbyImageContentLobbyIdGet$Params, context?: HttpContext): Observable<Array<LobbyImageModel>> {
    return this.lobbyLobbyImageContentLobbyIdGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<Array<LobbyImageModel>>): Array<LobbyImageModel> => r.body)
    );
  }

}
